function tryParseJSON(maybeJsonString) {
    let parsedJsonString;
    try {
        parsedJsonString = JSON.parse(maybeJsonString);
    } catch(_) {
        parsedJsonString = null;
    }
    return parsedJsonString;
}

export default {
    tryParseJSON
};
